export enum configPermission {
  CREATE = 0,
  READ = 1,
  UPDATE = 2,
  DELETE = 3,
}
